"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DurationGeneralHandler", {
    enumerable: true,
    get: function() {
        return DurationGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _numbergeneralhandler = require("../number/number.general.handler");
let DurationGeneralHandler = class DurationGeneralHandler extends _numbergeneralhandler.NumberGeneralHandler {
    async parseUserInput(params) {
        var _ref;
        var _parseProp;
        // Allow null/undefined/empty values
        if (params.value === null || params.value === undefined || params.value === '') {
            return {
                value: null
            };
        }
        let finalValue;
        // Get duration type from column meta
        const durationType = (_ref = (_parseProp = (0, _nocodbsdk.parseProp)(params.column.meta)) == null ? void 0 : _parseProp.duration) != null ? _ref : 0;
        // Check if the value is a duration string format
        if (typeof params.value === 'string') {
            const trimmedValue = params.value.trim();
            // Try to parse as duration string (e.g., "00:02:33.000")
            const durationResult = (0, _nocodbsdk.convertDurationToSeconds)(trimmedValue, durationType);
            if (durationResult._isValid) {
                finalValue = durationResult._sec;
            } else {
                // If not a valid duration string, try to parse as number
                const numberValue = Number(trimmedValue);
                if (isNaN(numberValue)) {
                    _catchError.NcError.invalidValueForField({
                        value: params.value,
                        column: params.column.title,
                        type: params.column.uidt
                    });
                }
                finalValue = numberValue;
            }
        } else if (typeof params.value === 'number') {
            finalValue = params.value;
        } else {
            // Try to convert to number
            const numberValue = Number(params.value);
            if (isNaN(numberValue)) {
                _catchError.NcError.invalidValueForField({
                    value: params.value,
                    column: params.column.title,
                    type: params.column.uidt
                });
            }
            finalValue = numberValue;
        }
        // Validate that duration is non-negative
        if (finalValue < 0) {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
        return {
            value: finalValue
        };
    }
};
